<template>
    <div class="RiskRequirementAlerts">
        <CriteriaDangerMessage v-if="showValidationErrors && isInvalidCriteriaMessage">
            <div class="flex flex-col gap-2">
                <span class="font-bold">Configuration Required</span>
                Some criteria require configuration. Click the settings icon next to any criteria to configure.
            </div>
        </CriteriaDangerMessage>
        <CriteriaWarningMessage v-if="hasDeprecatedCriteria">
            One or more criteria has been deprecated and may result in incorrect entity compliance.
        </CriteriaWarningMessage>
        <CriteriaWarningMessage
            v-if="showValidationErrors && isEvaluationRuleRequirementTypeAllCriteriaNotVerify"
        >
            At least 1 Criterion must be verified for the Evaluation Rule to stay valid.
            If not, the Evaluation Rule will be removed.
        </CriteriaWarningMessage>
    </div>
</template>

<style lang="scss">
    @import "../variables";

    .RiskRequirementAlerts {
        padding: $padding-y $padding-x;
    }
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import CriteriaDangerMessage from '@/modules/decisioning-criteria/components/CriteriaDangerMessage/CriteriaDangerMessage.vue';
    import CriteriaWarningMessage from '@/modules/decisioning-criteria/components/CriteriaWarningMessage/CriteriaWarningMessage.vue';

    export default defineComponent({
        name: 'RiskRequirementAlerts',
        components: {
            CriteriaWarningMessage,
            CriteriaDangerMessage,
        },
        props: {
            showValidationErrors: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            isEvaluationRuleRequirementTypeAllCriteriaNotVerify: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            hasDeprecatedCriteria: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            isInvalidCriteriaMessage: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
    });
</script>
